import { PrinterPosAlertIcon } from './PrinterPosAlertIcon';

/**
 * author: Colton Wiscombe
 * id 8303B276-1999-4F62-8C48-22EBA47B5781
 * name printer-pos-alert
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-alert.svg
 * tags
 * - Alert / Error 
 * - Printer 
 */
export const PrinterReceiptAlertIcon = PrinterPosAlertIcon;
export default PrinterReceiptAlertIcon